/**
 * The free project, "Livre" (the owner, 21/10/2026; docs/refactor/49): every organization has one, so whoever signs up
 * can ask the AI something at once — before a project of their own, or without being a developer. An organization from
 * before it existed, with no repository at all, asks the server for it; the desktop gives it a folder of its own (no
 * dialog) and takes its commands. On the web, agents run on a computer, as always.
 */

import type { RepositoryLink } from './types'

export type FreeProjectStep = { kind: 'ensure' } | { kind: 'folder'; name: string } | null

/** What is still missing, if anything: the free project itself, or its folder on this computer. */
export function freeProjectStep(
  repositories: RepositoryLink[] | undefined,
  folderFor: (name: string) => string | null,
  desktop: boolean,
): FreeProjectStep {
  if (!repositories) return null
  if (repositories.length === 0) return { kind: 'ensure' }
  const free = repositories.find((r) => r.isDefault && r.linked)
  if (!free || !desktop || folderFor(free.name)) return null
  return { kind: 'folder', name: free.name }
}
